export enum SortingType {
  newest = 0,
  oldest = 1,
};
